import { PublicClientApplication } from '@azure/msal-browser';
import { KlikProvider, theme } from '@lego/klik-ui';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { msalConfig } from './msal-config';

const msalInstance = new PublicClientApplication(msalConfig);

void msalInstance.initialize().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <KlikProvider
        includeFont={true}
        theme={{
          ...theme,
          breakpoints: {
            '2xl': '96em',
            lg: '62em',
            md: '50em',
            sm: '40em',
            xl: '80em',
          },
        }}
      >
        <App msalInstance={msalInstance} />
      </KlikProvider>
    </React.StrictMode>
  );
});
